module.exports = __webpack_public_path__ + "media/images/lv_flag-bc4d7ddab707d1a2c6bd655d86f7bfbd.svg";